/**
 * <pre>
 * Sharing config.
 *
 * Summary of responsibilities:
 *
 *  - defines any commonly used config values specific to Sharing.
 * </pre>
 *
 * @author Tim Loram
 *
 * @memberof module:Sharing
 * @namespace
 *
 * @type {Object}
 */
const Config = {

	// The key to use when creating the root store using combineReducers.
	stateKey: 'sharing'
};

export default Config;
